import React from 'react';
import { FaClock } from 'react-icons/fa';

const TimeSetupModal = ({
  customTime,
  setCustomTime,
  topic
}) => {
  return (
    <div className="p-2 rounded-2xl border bg-white shadow-sm space-y-2">
      <h3 className="font-semibold flex items-center gap-3 text-[#861426]">
        Exam Time Setup
      </h3>

      <div>
        <label className="text-sm font-semibold text-gray-700">
          Exam Duration (minutes)
        </label>
        <input
          type="number"
          min="1"
          max="120"
          value={customTime}
          onChange={(e) => setCustomTime(e.target.value)}
          className=" w-full rounded-xl border px-2 py-1 "
        />
        <p className="text-xs text-gray-500 mt-1">
          Default: {topic?.transcriptionTime || 1} min
        </p>
      </div>

      {(!customTime || parseInt(customTime) <= 0) && (
        <p className="text-sm text-red-600">
          Please enter a valid time (1–120 minutes)
        </p>
      )}
    </div>
  );
};

export default TimeSetupModal;
